import { CorrelationSchemeMF, GeoModuleMF, TableMF, Window2DMF, Window3DMF } from '@core/core/pages'
import type { TabType } from '@library/model'
import { constructBrowserTabUrl } from '@library/model'
import type { GetTokenType, TabId } from 'common/types'
import type { ReactElement } from 'react'

import { TabPlaceholder } from './TabPlaceholder'

export const getTabApp = (type: TabType, tabId: TabId, getToken?: GetTokenType): ReactElement => {
  switch (type) {
    case 'Window3D':
      return <Window3DMF tabId={tabId} getToken={getToken} />
    case 'Interpretation':
      return <Window2DMF tabId={tabId} getToken={getToken} />
    case 'CrossPlot':
      return (
        <TabPlaceholder
          title="Когда-то тут был кроссплот..."
          description="...но теперь он переехал в отдельное окно :)"
          urlConstructor={projectId => constructBrowserTabUrl('CrossPlotBrowser', projectId)}
        />
      )
    case 'Table':
      return <TableMF tabId={tabId} getToken={getToken} />
    case 'CorrelationScheme':
      return <CorrelationSchemeMF tabId={tabId} getToken={getToken} />
    case 'GeoModule':
      return <GeoModuleMF tabId={tabId} getToken={getToken} />
    case 'Window2D':
    case 'Chart':
    case 'Map':
      return (
        <TabPlaceholder
          title="Пока тут ничего нет"
          description="Но обязательно появится, заглядывайте почаще:)"
        />
      )
  }
}
